import { addressSchema } from '../../../schemas/address.schema';
import { z } from 'zod/v4';

export const fleetCustomPlaceSchema = z.object({
  id: z.number(),
  guid: z.string(),
  deleted: z.boolean(),
  setId: z.number(),
  categoryId: z.number(),
  companyId: z.string().nullable(),
  phone: z.string().nullable(),
  placeType: z.string(),
  info: z.string().nullable(),
  siteId: z.number().nullable(),
  address: addressSchema
    .extend({
      country: z.string().nullable(),
      state: z.string().nullable(),
    })
    .omit({
      extendedAddress: true,
      postalCode: true,
      streetName: true,
      streetNumber: true,
    }),
  coords: z.object({
    lat: z.string(),
    lon: z.string(),
  }),
  placeName: z.string(),
  promotable: z.boolean(),
  trimblePlaceId: z.string(),
});

export type FleetCustomPlace = z.infer<typeof fleetCustomPlaceSchema>;
